<template>
  <div>
    <section class="documentos container">
      <h2 class="text-center mt-3">
        Documentos
      </h2>
      <div class="text-center">
        <mdb-btn
          color="primary"
          icon="file-medical"
          @click="abrirFormulario('Agregar')"
        >
          Agregar nuevo
        </mdb-btn>
      </div>
      <ul class="requirement-list">
        <li
          v-for="req in requirements"
          :key="req.name"
        >
          <Documento
            v-if="req.name"
            :requirement="req"
          >
            <template v-slot:botones>
              <mdb-btn
                flat
                dark-waves
                icon="pen"
                title="Editar"
                class="mr-0"
                @click="abrirFormulario('Guardar',req)"
              />
              <mdb-btn
                flat
                dark-waves
                text="danger"
                icon="minus-circle"
                title="Eliminar"
                class="ml-0"
                @click="showConfirmation = true;requirement=req"
              />
            </template>
          </Documento>
        </li>
      </ul>
    </section>
    <section>
      <!--
        Modal para agregar /
        modificar un documento
      -->
      <mdb-modal
        :show="showForm"
        elegant
        @close="showForm = false"
      >
        <mdb-modal-header>
          <mdb-modal-title>Modal title</mdb-modal-title>
        </mdb-modal-header>
        <mdb-modal-body>
          <div class="container text-center">
            <form @submit.prevent="validateForm">
              <div class="row justify-content-around">
                <div class="col-12">
                  <div class="my-0 md-form md-outline md-outline-input-focus">
                    <input
                      id="req-name"
                      v-model="requirement.name"
                      type="text"
                      class="form-control"
                      minlength="5"
                      required
                    >
                    <label
                      for="req-name"
                      :class="requirement.name ? 'mr-5 label-active' : 'mr-5'"
                    >
                      Nombre del requisito
                    </label>
                  </div>
                </div>
                <p class="col-12 mb-2 text-center font-weight-bold">
                  Tipo
                </p>
                <div
                  v-for="type in types"
                  :key="type"
                  class="col-6 our-checkbox"
                >
                  <input
                    :id="type"
                    v-model="requirement.type"
                    :value="type"
                    type="checkbox"
                    class=""
                  >
                  <label :for="type">
                    {{ type }}
                  </label>
                </div>
              </div>
              <div class="row justify-content-around">
                <mdb-btn
                  class="order-2 order-sm-1"
                  color="blue-grey"
                  icon="times"
                  type="button"
                  @click="showForm = false"
                >
                  Cancelar
                </mdb-btn>
                <mdb-btn
                  class="order-1 order-sm-2"
                  color="primary"
                  :icon="btnLabel.icon"
                  :disabled="btnDisabled"
                >
                  <font-awesome-icon
                    v-if="btnDisabled"
                    icon="circle-notch"
                    spin
                    size="lg"
                  />
                  {{ btnLabel.nombre }}
                </mdb-btn>
              </div>
            </form>
          </div>
        </mdb-modal-body>
      </mdb-modal>
      <!--
        Modal para confirmar la
        eliminación de un documento
      -->
      <mdb-modal
        class="be-bottom"
        direction="bottom"
        :show="showConfirmation"
        @close="showConfirmation = false"
      >
        <mdb-modal-body class="delete-document">
          <p class="my-2">
            ¿Está seguro que desea eliminar el documento
            <span class="font-weight-bold">{{ requirement.name }}</span>?
          </p>
          <div class="buttons">
            <mdb-btn
              class="order-2 order-sm-1"
              color="blue-grey"
              icon="times"
              @click="showConfirmation = false"
            >
              Cancelar
            </mdb-btn>
            <mdb-btn
              class="order-1 order-sm-2"
              color="danger"
              icon="minus-circle"
              @click="requirementDelete()"
            >
              Eliminar
            </mdb-btn>
          </div>
        </mdb-modal-body>
      </mdb-modal>
      <AlertaMsj :alerta-msj="alertaMsj" />
    </section>
  </div>
</template>
<script>
import Documento from '../components/Documento.vue';
import AlertaMsj from '../components/AlertaMsj.vue';
import {mdbModal, mdbModalHeader, mdbModalTitle,
  mdbModalBody, mdbBtn} from 'mdbvue';
import gql from 'graphql-tag';
import requirementCreateGql from '../graphql/requirementCreate.gql';
import requirementsGql from '../graphql/requirements.gql';
import requirementUpdateGql from '../graphql/requirementUpdate.gql';
import requirementDeleteGql from '../graphql/requirementDelete.gql';
export default {
  name: 'Documentos',
  components: {
    Documento,
    AlertaMsj,
    mdbModal,
    mdbModalHeader,
    mdbModalTitle,
    mdbModalBody,
    mdbBtn,
  },
  data() {
    return {
      showForm: false,
      showConfirmation: false,
      btnLabel: {},
      alertaMsj: {
        content: '',
      },
      requirement: {},
      requirementTemp: {},
      types: ['Imagen', 'PDF'],
      requirements: [],
      btnDisabled: false,
    };
  },
  methods: {
    abrirFormulario(btnLabel, item) {
      this.showForm = true;
      this.requirement={type: []};
      this.btnLabel.nombre = btnLabel;
      if (btnLabel == 'Agregar') {
        this.btnLabel.icon = 'file-medical';
      } else {
        this.requirementTemp=item;
        this.requirement=JSON.parse(JSON.stringify(item));
        this.btnLabel.icon = 'redo-alt';
      }
    },
    validateForm(event) {
      event.target.classList.add('was-validated');
      if (!this.requirement.name) {
        return this.alertaMsj = {
          content: 'Llene los campos requeridos',
          type: 'warning',
        };
      }
      if (!this.requirement.type.length) {
        return this.alertaMsj = {
          content: 'Seleccione un tipo de documento',
          type: 'warning',
        };
      }
      if (this.btnLabel.nombre == 'Agregar') {
        this.requirementCreate();
      } else {
        this.requirementUpdate();
      }
    },
    requirementDelete() {
      this.$apollo.mutate({
        mutation: gql`${requirementDeleteGql}`,
        variables: {
          name: this.requirement.name,
        },
      }).then((res) => {
        // this.requirement.name = false;
        this.requirements
            .splice(this.requirements.indexOf(this.requirement), 1);
        this.showForm = false;
        this.alertaMsj = {
          content: 'El documento a sido eliminado con exito',
          type: 'success',
        };
      }).catch((error) => {
        this.showForm = false;
        this.alertaMsj = {
          content: 'Hubo un error al eliminar el documento',
          type: 'danger',
        };
      });
      this.showConfirmation = false;
    },
    requirementCreate() {
      this.btnDisabled = true;
      this.btnLabel = {};
      this.$apollo.mutate({
        mutation: gql`${requirementCreateGql}`,
        variables: {
          requirement: this.requirement,
        },
      }).then((res) => {
        this.requirements.push(this.requirement);
        this.btnDisabled = false;
        this.showForm = false;
        this.alertaMsj = {
          content: 'El documento ha sido agregado con éxito',
          type: 'success',
        };
      }).catch((error) => {
        this.btnDisabled = false;
        this.showForm = false;
        this.alertaMsj = {
          content: 'Hubo un error al agregar documento',
          type: 'danger',
        };
      });
    },
    requirementUpdate() {
      this.btnDisabled = true;
      this.btnLabel = {};
      this.$apollo.mutate({
        mutation: gql`${requirementUpdateGql}`,
        variables: {
          name: this.requirementTemp.name,
          requirement: {
            name: this.requirement.name,
            type: this.requirement.type,
          },
        },
      }).then((res) => {
        Object.assign(this.requirementTemp, {...this.requirement});
        this.btnDisabled = true;
        this.showForm = false;
        this.alertaMsj = {
          content: 'El documento ha sido actualizado con éxito',
          type: 'success',
        };
      }).catch((error) => {
        this.btnDisabled = true;
        this.showForm = false;
        this.alertaMsj = {
          content: 'Hubo un error al editar documento',
          type: 'danger',
        };
      });
    },
  },
  apollo: {
    requirements() {
      return {
        query: gql`${requirementsGql}`,
        update: (data) => data.Requirement,
      };
    },
  },
};
</script>
